// extracted by mini-css-extract-plugin
export default {"modalContainer":"f1-z","modalIndicator":"g1-z","prevBtn":"h1-z","nextBtn":"i1-z","body":"j1-z","footer":"k1-z"};